import { Select, SelectProps } from 'antd';
import { useGetPractitionerList } from 'src/hooks/practitioner';
import styled from '@emotion/styled';
import { PractitionerName } from './practitionerName';
import { UserOutlined } from '@ant-design/icons';
import { getPractitionerName } from 'src/utils/practitioner';
import { useState } from 'react';

const StyledSelect = styled(Select)`
  .ant-select-prefix {
    margin-right: 8px;
  }
  ${({ variant }) =>
    variant === 'borderless' &&
    `
      & .ant-select-selector {
        padding-left: 0 !important;
      }
    `}
`;

type PractitionerDropdownProps = Pick<
  SelectProps,
  | 'value'
  | 'onChange'
  | 'loading'
  | 'disabled'
  | 'showSearch'
  | 'variant'
  | 'mode'
  | 'prefix'
  | 'placeholder'
  | 'allowClear'
> & {
  labelRender?: (
    props: Parameters<Exclude<SelectProps['labelRender'], undefined>>[0],
    state: {
      isOpen: boolean;
      isLoading: boolean;
    }
  ) => React.ReactNode;
};

const defaultLabelRendere: PractitionerDropdownProps['labelRender'] = ({
  label,
}) => {
  return label ? label : '...';
};

export const PractitionerDropdown = (props: PractitionerDropdownProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const { data: practitionerList, isLoading: isLoadingPractitionerList } =
    useGetPractitionerList({
      is_shown: true,
    });

  const labelRender = props.labelRender || defaultLabelRendere;

  return (
    <StyledSelect
      placeholder="Practitioner"
      {...props}
      dropdownStyle={{ minWidth: 'fit-content' }}
      popupMatchSelectWidth={false}
      prefix={<UserOutlined />}
      filterOption={(input, option) => {
        return (option as any)?.practitioner.full_name
          ?.toLowerCase()
          .includes(input.toLowerCase());
      }}
      onOpenChange={setIsOpen}
      optionRender={(option) => {
        return (
          <PractitionerName practitioner={(option as any).data.practitioner} />
        );
      }}
      labelRender={(option) =>
        labelRender?.(option, {
          isOpen,
          isLoading: isLoadingPractitionerList,
        })
      }
      options={practitionerList?.practitioners.map((practitioner) => ({
        label: getPractitionerName(practitioner),
        value: practitioner.practitioner_id,
        practitioner,
      }))}
    />
  );
};
